import { DateTimeService, DateTimeUtcService, useAppClockService, useTimezone } from '@mews/framework';
import { DEFAULT_PREAUTHORIZATION_EXPIRATION_DAYS } from '@mews-commander/legacy-entities/src/constants';
import { MAX_PREAUTHORIZATION_EXPIRATION_DAYS } from '../../../constants';

export const useGetPreauthorizationDateTimesUtc = () => {
    const appClockService = useAppClockService();
    const nowDateTimeUtc = appClockService.getAppNowUtc();
    const preathMinDateTimeUtc = DateTimeUtcService.addDays(nowDateTimeUtc, 1);
    const preathMaxDateTimeUtc = DateTimeUtcService.addDays(nowDateTimeUtc, MAX_PREAUTHORIZATION_EXPIRATION_DAYS);
    const preathDefaultDateTimeUtc = DateTimeUtcService.addDays(
        nowDateTimeUtc,
        DEFAULT_PREAUTHORIZATION_EXPIRATION_DAYS
    );

    return {
        minDateTimeUtc: preathMinDateTimeUtc,
        maxDateTimeUtc: preathMaxDateTimeUtc,
        defaultDateTimeUtc: preathDefaultDateTimeUtc,
    };
};

export const useGetExpirationUtcWithTimeNow = () => {
    const timezone = useTimezone();
    const appClockService = useAppClockService();

    return (expirationUtc: string) => {
        const dateTimeNow = DateTimeService.fromUtc(appClockService.getAppNowUtc(), timezone);
        const timeNow = DateTimeService.toTime(dateTimeNow);

        const expirationDate = DateTimeService.toDate(DateTimeService.fromUtcString(expirationUtc, timezone));
        const expirationDateTimeWithTimeNow = DateTimeService.fromDateAndTime(expirationDate, timeNow);
        return DateTimeService.toUtc(expirationDateTimeWithTimeNow).value;
    };
};
